<template>
  <div class="home" style="height:100%;overflow: auto;">
    <el-backtop target=".home"></el-backtop>
    
    <el-dialog
      title="📢 登录公告"
      :visible.sync="loginAnnouncementVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      center>
      <div style="padding: 20px; text-align: left; line-height: 1.8;">
        <h3 style="color: #409EFF; margin-bottom: 15px;">{{ announcement.title }}</h3>
        <p style="color: #666; text-indent: 2em; margin-bottom: 10px;">{{ announcement.content }}</p>
        <div style="background: #fdf6ec; padding: 18px; border-radius: 8px; margin-top: 20px; border: 1px solid #faecd8;">
          <h4 style="color: #E6A23C; margin-bottom: 12px; font-size: 15px;">⚠️ 重要提示</h4>
          <ul style="color: #666; padding-left: 20px; line-height: 2;">
            <li style="margin-bottom: 8px; font-weight: 500; color: #e6a23c;">必须本人学习，否则学习无效，相关责任由学员自行承担</li>
            <li style="margin-bottom: 8px;">建议使用谷歌浏览器、Edge浏览器，防止进度保存失败</li>
            <li style="margin-bottom: 8px;">系统只记录实际学习时间，快进无效</li>
            <li>请保持摄像头正常开启，学习过程系统会随机抓拍</li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAnnouncement" size="medium">我知道了</el-button>
      </span>
    </el-dialog>
    
    <Header/>
    <Banner/>
<!--    <Notice />-->
<!--    <Todo v-if="isLOgin"/>-->
    <div v-for="(item, i) in subList" :key="item.id">
      <Special :title="item.cateName" :children="item.courseList" />
    </div>
    <Buy v-if="isLOgin"/>
<!--    <div v-for="(item, i) in subList" :key="item.id">-->
<!--      <Special :title="item.cateName" :children="item.children" />-->
<!--    </div>-->

<!--    <RankList/>-->
    <!-- 通知公告 -->
    <Footer/>
  </div>
</template>

<script>
import Header from "./header/index";
import Banner from "./banner/index";
import Learning from "./learningCenter/index";
// import Graphical from "./graphical/index";
import Notice from "./notice/index"
import Todo from "./todo/index";
import Buy from "./buy/index";

// import Recommend from "./informationRecommend/index";
// import Subject from "./subjectRecommend/index";
import Special from "./specialSubject/index";
// import WebB from "./webBottom/index";
import Footer from "./footer";
import RankList from "./rankList"
import {getCategory} from '@/api/home'
import { getToken } from '@/utils/auth'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Header,
    Banner,
    Learning,
    // Graphical,
    Todo,
    Buy,
    // Recommend,
    // Subject,
    Special,
    // WebB,
    Footer,
    RankList,
    Notice
  },
  data() {
    return {
      subList:[],
      userinfo: {},
      loginAnnouncementVisible: false,
      announcement: {
        title: '学习须知',
        content: '为了防止进度保存失败，建议使用谷歌浏览器、Edge浏览器进行学习，系统只记录实际学习时间，快进无效！'
      }
    };
  },
  created() {
    this.checkLoginAnnouncement();
    this.getCategoryList()
  },
  computed: {
    isLOgin: function() {
      return getToken()
    },
  },
  methods: {
    checkLoginAnnouncement() {
      if (!getToken()) return;
      const hasShown = sessionStorage.getItem('loginAnnouncementShown');
      if (!hasShown) {
        setTimeout(() => {
          this.loginAnnouncementVisible = true;
        }, 500);
      }
    },
    confirmAnnouncement() {
      sessionStorage.setItem('loginAnnouncementShown', 'true');
      this.loginAnnouncementVisible = false;
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let res = this.account.filter(
              (item) =>
                  this.form.username === item.username &&
                  this.form.password === item.password
          );
          this.dialogVisible = res.length === 0;
          if (this.dialogVisible) {
            this.$message({
              type: "error",
              message: "用户名或密码不正确！",
            });
          } else {
            this.setLocal(res[0]);
          }
        } else {
          return false;
        }
      });
    },
    getLocal() {
      return localStorage.getItem("userinfo");
    },
    setLocal(val) {
      localStorage.setItem("userinfo", JSON.stringify(val));
    },
    // 获取分类
    async getCategoryList(){
      try {
        const res = await getCategory()
        this.subList = res.data
      } catch (error) {
        console.log(error);
      }
    }
  },
};
</script>
<style scoped lang="scss">
.home {
  height: 100%;
  // padding-bottom: 50px;
  position: relative;
  overflow-y: auto;

  .login-form {
    width: 100%;
    height: 100%;
  }
}

</style>
